import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col h-full w-full items-center justify-center p-4 text-4xl"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "mb-8"
}, "footy", -1);
const _hoisted_3 = {
  class: "mb-4"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_NButton, {
        type: "success",
        strong: "",
        size: "large",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push({
          name: 'game-slots.create'
        }))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('new_game')), 1)]),
        _: 1
      })]), _createVNode(_component_NButton, {
        type: "warning",
        strong: "",
        size: "large",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push({
          name: 'game-slots.index'
        }))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('load_game')), 1)]),
        _: 1
      })]);
    };
  }
});